import { RewardsFilter, RedemptionStepNumber, RedemptionStepName } from 'interfaces/bounty'
import { BaseSorting } from 'interfaces/table'

export const REWARD_FILTERS: RewardsFilter[] = [
  'all',
  'pending',
  'confirmed',
  'earned',
  'expired',
  'dismissed',
  'crypto',
]
export const MIN_ACCOUNT_NUMBER_LENGTH = 5
export const MAX_ACCOUNT_NUMBER_LENGTH = 17
export const ROUTING_NUMBER_LENGTH = 9
export const MIN_REDEMPTION_AMOUNT = 10 // don't use it for validation or calculation, only for copy
export const MAX_REDEMPTION_CONFIRMATION_TERM = 60

export const SEPARATED_NUMBER_REGEX = /^\d[-\s\d]*$/
export const ACCOUNT_NUMBER_REGEX = new RegExp(`^\\d{${ MIN_ACCOUNT_NUMBER_LENGTH },${ MAX_ACCOUNT_NUMBER_LENGTH }}$`)
export const ROUTING_NUMBER_REGEX = new RegExp(`^\\d{${ ROUTING_NUMBER_LENGTH },${ ROUTING_NUMBER_LENGTH }}$`)
export const NO_DIGITS_REGEX = /[^\d]/g

export const DEFAULT_REDEMPTIONS_SORTING: BaseSorting = {
  direction: 'desc',
  columnName: 'date',
}

export const REDEMPTION_AMOUNT_STEP_NUMBER = 0
export const REDEMPTION_AMOUNT_STEP_NAME = 'amount'
export const REDEMPTION_ACCOUNT_STEP_NUMBER = 1
export const REDEMPTION_ACCOUNT_STEP_NAME = 'account'
export const REDEMPTION_CONFIRM_STEP_NUMBER = 2
export const REDEMPTION_CONFIRM_STEP_NAME = 'confirm'
export const REDEMPTION_SUCCESS_STEP_NUMBER = 3
export const REDEMPTION_SUCCESS_STEP_NAME = 'success'

export const REDEMPTION_LAST_STEP_NUMBER = REDEMPTION_SUCCESS_STEP_NUMBER

export const REDEMPTION_STEP_NAME_BY_STEP_NUMBER: Record<RedemptionStepNumber, RedemptionStepName> = {
  [REDEMPTION_AMOUNT_STEP_NUMBER]: REDEMPTION_AMOUNT_STEP_NAME,
  [REDEMPTION_ACCOUNT_STEP_NUMBER]: REDEMPTION_ACCOUNT_STEP_NAME,
  [REDEMPTION_CONFIRM_STEP_NUMBER]: REDEMPTION_CONFIRM_STEP_NAME,
  [REDEMPTION_SUCCESS_STEP_NUMBER]: REDEMPTION_SUCCESS_STEP_NAME,
}

export const REDEMPTION_STEP_NUMBER_BY_STEP_NAME: Record<RedemptionStepName, RedemptionStepNumber> = {
  [REDEMPTION_AMOUNT_STEP_NAME]: REDEMPTION_AMOUNT_STEP_NUMBER,
  [REDEMPTION_ACCOUNT_STEP_NAME]: REDEMPTION_ACCOUNT_STEP_NUMBER,
  [REDEMPTION_CONFIRM_STEP_NAME]: REDEMPTION_CONFIRM_STEP_NUMBER,
  [REDEMPTION_SUCCESS_STEP_NAME]: REDEMPTION_SUCCESS_STEP_NUMBER,
}
